import React from 'react';
import type { SlidePreviewProps } from '../types';
import { getSlidePreview } from './getSlidePreview';

export const SlidePreview = React.memo((props: SlidePreviewProps) => {
  const Preview = getSlidePreview(props.data);

  return <Preview {...props} />;
});
